@use "../../styles/breakpoint.module.scss" as *;

.root {
    --step-bar-offset: 64px;
    --step-label-row-height: 22px;
    --step-gap: 8px;
    --step-track-height: 2px;
    --card-step-clearance: 24px;
    --step-bar-height: calc(
        var(--step-label-row-height) + var(--step-gap) +
            var(--step-track-height)
    );

    position: relative;
    overflow: hidden;
}

.slideContainer {
    width: 100%;
    vertical-align: top;
}

.slide {
    position: relative;
    aspect-ratio: 375 / 667;

    @media ($above-tablet) {
        aspect-ratio: 1440 / 856;
    }
}

.mediaContainer {
    position: absolute;
    inset: 0;

    img,
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    // Hide VideoPlayerControls mute/play buttons; these videos have no audio
    // and playback is managed by the carousel's own autoplay control.
    button {
        display: none;
    }
}

.gradientOverlay {
    position: absolute;
    inset: 0;
    background: var(--overlay-gradient);
    pointer-events: none;
}

.card {
    --card-top: 16px;

    position: absolute;
    top: var(--card-top);
    left: 50%;
    transform: translateX(-50%);
    width: 343px;
    z-index: 1;

    // Keep the card out of the step bar's lane on height-constrained
    // viewports; the card scrolls internally when capped.
    max-height: calc(
        100% - var(--card-top) - var(--step-bar-offset) - var(
                --step-bar-height
            ) - var(--card-step-clearance)
    );
    overflow-y: auto;

    @media ($above-tablet) {
        --card-top: 56px;

        left: auto;
        right: 80px;
        transform: none;
        width: 437px;
    }
}

// Override SKSArrows positioning and appearance for this block
.arrows {
    z-index: 2;
    inset: 0;
    align-items: center;
    padding-inline: var(--labui-container-margin);
}

.dots {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;

    @media ($above-tablet) {
        display: none;
    }
}

.pauseButton {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    fill: var(--color-contrast);
    transform: translateY(-1px);
}

// Step progress bar — overlaid at the bottom of the image area
.stepBar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: var(--step-bar-offset);
    z-index: 2;
    display: flex;
    gap: 18px;
    padding-inline: 16px;

    @media ($above-tablet) {
        padding-inline: 45px;
    }
}

.step {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--step-gap);
    min-width: 0;

    @media ($below-mobile) {
        display: none;

        &.stepActive {
            display: flex;
            flex: none;
            width: 343px;
        }
    }
}

.stepLabelRow {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: var(--step-label-row-height);
}

.stepLabel {
    font: var(--font-eyebrow-12);
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: var(--color-contrast);
    opacity: 0.6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
}

.stepActive .stepLabel {
    opacity: 1;
}

.stepTrack {
    position: relative;
    height: var(--step-track-height);
    background: rgb(141 141 141 / 40%);
}

.stepTrackFill {
    position: absolute;
    inset-block: 0;
    left: 0;
    width: calc(var(--autoplay-progress, 0) * 100%);
    background: rgb(185 185 185 / 70%);
}
